import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from './DotPagination.styles';
const DotPagination = ({ autoplay = 0, ariaLabel, count, paused = false, value, onAutoUpdate, onChange, onPlayClick = () => {
    return;
}, showPlayControls, }) => {
    const useAutoplay = autoplay > 0;
    const animateActive = useAutoplay && !paused;
    React.useEffect(() => {
        onAutoUpdate && onAutoUpdate(value);
    }, [value]);
    return (React.createElement(S.Container, { "aria-label": ariaLabel },
        showPlayControls && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.PlayPauseButton, { "data-paused": paused, onClick: onPlayClick, "aria-label": `${paused ? 'Resume' : 'Pause'} banner scrolling` }))),
        Array.from(Array(count)).map((_, index) => {
            return (React.createElement(S.Item, { key: `DotPaginationItem_${index}`, "data-animate": animateActive, "aria-current": index === value, "aria-label": `Go to ${index + 1}`, onClick: (event) => {
                    event.preventDefault();
                    onChange(index);
                } }));
        })));
};
export default DotPagination;
